(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shineneon-faq-center"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.sn-faq-center:not([data-faq-ready])');

    sections.forEach((section) => {
      section.setAttribute('data-faq-ready', 'true');

      const form = section.querySelector('[data-faq-search-form]');
      const input = section.querySelector('[data-faq-search-input]');
      const clearButton = section.querySelector('[data-faq-clear]');
      const items = [...section.querySelectorAll('[data-faq-item]')];
      const topicButtons = [...section.querySelectorAll('[data-faq-topic]')];
      const resultTitle = section.querySelector('[data-faq-results-title]');
      const resultDescription = section.querySelector('[data-faq-results-description]');
      const resultCount = section.querySelector('[data-faq-count]');
      const emptyState = section.querySelector('[data-faq-empty]');
      const results = section.querySelector('.sn-faq-center__results');
      const strings = {
        popular: resultTitle.textContent.trim(),
        popularDescription: resultDescription.textContent.trim(),
        allDescription: section.querySelector('.sn-faq-center__section-heading p').textContent.trim(),
        design: section.querySelector('[data-faq-topic="design"] strong').textContent.trim(),
        ordering: section.querySelector('[data-faq-topic="ordering"] strong').textContent.trim(),
        product: section.querySelector('[data-faq-topic="product"] strong').textContent.trim(),
        support: section.querySelector('[data-faq-topic="support"] strong').textContent.trim(),
        resultsFor: section.dataset.resultsFor,
        searchingDescription: section.dataset.searchingDescription,
        answerOne: section.dataset.answerOne,
        answerOther: section.dataset.answerOther,
      };
      let activeTopic = 'all';

      const searchableText = (item) => `${item.textContent} ${item.dataset.keywords || ''}`.toLowerCase();

      const applyFilters = () => {
        const rawQuery = input.value.trim();
        const query = rawQuery.toLowerCase();
        const queryWords = query.split(/\s+/).filter(Boolean);
        let visibleCount = 0;

        items.forEach((item) => {
          const matchesTopic = activeTopic === 'all'
            ? (query ? true : item.dataset.popular === 'true')
            : item.dataset.topic === activeTopic;
          const itemText = searchableText(item);
          const matchesQuery = queryWords.every((word) => itemText.includes(word));
          const visible = matchesTopic && matchesQuery;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        clearButton.hidden = !query;
        resultTitle.textContent = query ? `${strings.resultsFor} “${rawQuery}”` : (activeTopic === 'all' ? strings.popular : strings[activeTopic]);
        resultDescription.textContent = query ? strings.searchingDescription : (activeTopic === 'all' ? strings.popularDescription : strings.allDescription);
        resultCount.textContent = `${visibleCount} ${visibleCount === 1 ? strings.answerOne : strings.answerOther}`;
        emptyState.hidden = visibleCount !== 0;
      };

      const chooseTopic = (topic, shouldScroll = true) => {
        activeTopic = topic;
        topicButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.faqTopic === activeTopic));
        });
        applyFilters();
        if (shouldScroll) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        activeTopic = 'all';
        topicButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.faqTopic === 'all')));
        applyFilters();
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      input.addEventListener('input', applyFilters);
      clearButton.addEventListener('click', () => {
        input.value = '';
        input.focus();
        applyFilters();
      });

      topicButtons.forEach((button) => {
        button.addEventListener('click', () => chooseTopic(button.dataset.faqTopic));
      });

      section.querySelectorAll('[data-faq-query]').forEach((button) => {
        button.addEventListener('click', () => {
          input.value = button.dataset.faqQuery;
          activeTopic = 'all';
          topicButtons.forEach((topicButton) => topicButton.setAttribute('aria-pressed', String(topicButton.dataset.faqTopic === 'all')));
          applyFilters();
          results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      applyFilters();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
